import "./ChipFilterInput.scss"
import { Autocomplete, ClickAwayListener, darken, lighten, Paper, Popper, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import Chip from '@mui/material/Chip';
import DeleteIcon from "@mui/icons-material/Cancel";


interface IChipFilterInput {
    label: string
    value: string | null,
    valueChanged: (value: string) => void
    inputWidth?: string,
    size?: "small" | "medium",
    placeholder?: string,
    selectPlacement?: 'dropdown' | 'hover'
}


const ChipFilterInput = (props: IChipFilterInput) => {

    const [inputValue, setInputValue] = useState<string>("");
    const [showPopup, setShowPopup] = useState(false)

    const inputRef = useRef<HTMLElement | null>(null);

    const removeValue = (valueIndex: number) => {
        if(props.value){
            const splitValue = props.value.split(",")
            const newValue = splitValue.filter((x, i) => i !== valueIndex)
            props.valueChanged(newValue.join(","))
        }
    }

    const handleBlur = () => {
        if (inputValue !== ""){
            const newValues = [...props.value?.split(",") || [], ...inputValue.split(",")]
            const uniqueValues = Array.from(new Set<string>(newValues)).filter((x) => x !== "")
            props.valueChanged(uniqueValues.join(","))
            setInputValue("")
        }
    }

    return (
            <div>
                {props.placeholder && <div className="chip-filter-label">{props.label}:</div>}
                <ClickAwayListener onClickAway={() => setShowPopup(false)}>
                    <Autocomplete
                        multiple
                        freeSolo 
                        limitTags={1}
                        options={[]}
                        ref={inputRef}
                        value={props.value ? props.value?.split(","): []}
                        renderValue={(values) => (
                            values.length >= 1 &&
                                <Typography sx={{color: (theme) => theme.palette.text.primary}}>
                                    <Chip 
                                        label={values[0]}
                                        onDelete={() => removeValue(0)}
                                        variant="filled"
                                        onClick={() => {}}
                                        clickable={false}
                                        sx={{maxWidth: 100}}
                                    />
                                    {values.length > 1 && <span style={{marginLeft: "5px"}}>+{values.length -1} more</span>}
                                </Typography>
                        )}
                        onChange={(event, newValue) => {
                            props.valueChanged(newValue.join(","));
                        }}
                        onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                        }}
                        renderInput={(params) => (
                            <TextField 
                                {...params} 
                                label={props.placeholder || props.label} 
                                onClick={() => setShowPopup(true)}
                                onFocus={() => setShowPopup(true)}
                                onBlur={handleBlur}
                            />
                        )}
                        inputValue={inputValue}
                        sx={{ width: props.inputWidth || '275px'}}
                        size={props.size || 'small'}
                    />
                </ClickAwayListener>
                {showPopup && props.value && props.value.split(",").length > 1 && (
                    <Popper
                        open
                        anchorEl={inputRef.current}
                        placement="bottom-start"
                        style={{ zIndex: 1300 }}
                        sx={{width: inputRef.current?.clientWidth}}
                    >
                        <Paper 
                            elevation={3} 
                            sx={(theme) => {
                                const base = theme.palette.background.paper;
                                let backgroundColor = base
                                // Dropdown blends in on black background
                                if (base === '#000000')
                                    backgroundColor = lighten(base, 0.08)

                                return {
                                    background: backgroundColor,
                                    maxHeight: 200, 
                                    overflow: 'auto', 
                                    padding: "5px"
                                };
                            }}
                        >
                            {props.value.split(",").map((item, index) => (
                                <>
                                    {index !== 0 && 
                                        <Chip 
                                            key={index} 
                                            label={item} 
                                            sx={{margin: "2px"}}
                                            onDelete={() => removeValue(index)}
                                            onClick={() => {}}
                                            clickable={false}
                                        />
                                    }
                                </>
                            ))}
                        </Paper>
                    </Popper>
                )}
            </div>
    )
}


export default ChipFilterInput